/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon20Regular = forwardRef('ArrowDCornerDownLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16.25 10.5a1.75 1.75 0 0 1-1.75 1.75H3.972l4.146-3.957a.75.75 0 0 0-1.036-1.086L2.72 11.373a2.25 2.25 0 0 0 0 3.255l4.363 4.165a.75.75 0 1 0 1.036-1.085L3.972 13.75H14.5a3.25 3.25 0 0 0 3.25-3.25V2a.75.75 0 1 0-1.5 0v8.5Z" })));
});
